import { createRouter, createWebHashHistory } from 'vue-router'
import { setShare } from '@/utils/bangban-util'

const routes = [
  {
    name: 'Home',
    path: '/',
    meta: {
      keepAlive: true, //设置页面是否需要使用缓存
      share: 'custom'
    },
    component: () => import('@/pages/help/views/homeView.vue')
  },
  {
    name: 'News',
    path: '/news',
    component: () => import('@/pages/help/views/newsView.vue')
  },
  {
    name: 'HotLine',
    path: '/hotLine',
    component: () => import('@/pages/help/views/hotLine.vue'),
    meta: { share: 'custom' }
  },
  {
    name: 'Detail',
    path: '/detail',
    component: () => import('@/pages/help/views/detailView.vue'),
    meta: { share: 'custom' }
  },
  {
    name: 'Publish',
    path: '/publish',
    component: () => import('@/pages/help/views/publishView.vue'),
    meta: { title: '报料' }
  },
  {
    name: 'Author',
    path: '/author',
    component: () => import('@/pages/help/views/authorView.vue')
  },
  {
    name: 'Topic',
    path: '/topic',
    component: () => import('@/pages/help/views/topicView.vue'),
    meta: { share: 'custom' }
  },
  {
    name: 'HotTopic',
    path: '/hotTopic',
    component: () => import('@/pages/help/views/hotTopic.vue'),
    meta: { title: '发现' }
  },
  {
    name: 'Moment',
    path: '/moment',
    component: () => import('@/pages/moment/App.vue')
  },
  {
    name: 'ChooseTag',
    path: '/chooseTag',
    component: () => import('@/pages/help/views/chooseTag.vue')
  },
  {
    name: 'Privacy',
    path: '/privacy',
    component: () => import('@/pages/help/views/privacyView.vue'),
    meta: { title: '佛山+民生帮办平台 | 免责声明' }
  },
  {
    name: 'MyReport',
    path: '/myReport',
    component: () => import('@/pages/help/views/myReport.vue'),
    meta: { title: '我的报料' }
  },
  {
    name: 'Reputation',
    path: '/reputation',
    component: () => import('@/pages/help/views/reputationView.vue'),
    meta: { title: '佛山口碑榜' }
  },
  {
    name: 'ReputationDetail',
    path: '/reputationDetail',
    component: () => import('@/pages/help/views/reputationDetail.vue'),
    meta: { title: '佛山口碑榜' }
  }
]

const router = createRouter({
  history: createWebHashHistory(process.env.NODE_ENV),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

router.beforeEach((to, _, next) => {
  const title = to?.meta?.title || '帮办'
  document.title = title

  if (to?.meta?.share !== 'custom') {
    setShare({ title })
  }

  next()
})

export default router
